import React from 'react'

export default function SuporteScreen () {
  return (
    <div>Suporte Screen</div>
  )
}
